import { SOURCE_LOCALE_ID } from "@bitcart/core/i18n";
import { useLocalStorage } from "@mantine/hooks";
import { useCallback, useMemo } from "react";
//#region src/client-locale.ts
/**
* Stores locale ID in localStorage and enforces read/write validation.
*
* Note that if the localStorage value is invalid, the default locale ID is used.
*/
const useClientLocaleId = ({ supportedLocaleIds }) => {
	const [persistedValue, setValue, _removeValue] = useLocalStorage({
		key: "localeId",
		defaultValue: SOURCE_LOCALE_ID,
		getInitialValueInEffect: false
	});
	return {
		clientLocaleId: useMemo(() => {
			if (persistedValue !== void 0 && supportedLocaleIds.includes(persistedValue)) return persistedValue;
			else return SOURCE_LOCALE_ID;
		}, [persistedValue, supportedLocaleIds]),
		setClientLocaleId: useCallback((localeId) => setValue(supportedLocaleIds.includes(localeId) ? localeId : SOURCE_LOCALE_ID), [setValue, supportedLocaleIds])
	};
};
//#endregion
export { useClientLocaleId };

//# sourceMappingURL=client-locale.js.map